import { GridHeaderCellProps } from '@progress/kendo-react-grid';
import { useCallback, useMemo } from 'react';
import ExpandCollapseCell from 'src/components/custom-cells/ExpandCollapseCell';
import useVarianceDetails from 'src/hooks/useVarianceDetails';

const VarianceGLPeriodHeaderCell = (props: GridHeaderCellProps) => {
  const { varianceGLPeriods, setVarianceGLPeriods } = useVarianceDetails();
  const isAllItemsExpanded = useMemo(
    () => varianceGLPeriods?.some((lineItem) => lineItem?.expanded),
    [varianceGLPeriods]
  );
  const handleHeaderCellExpand = useCallback(() => {
    setVarianceGLPeriods((prev) =>
      [...prev].map((item) => ({
        ...item,
        expanded: !isAllItemsExpanded,
        glCodeVariances: item.glCodeVariances.map((glCodeVariance) => ({
          ...glCodeVariance,
          expanded: !isAllItemsExpanded,
          itemVariances: glCodeVariance.itemVariances.map((item) => ({
            ...item,
            expanded: !isAllItemsExpanded,
          })),
        })),
      }))
    );
  }, [isAllItemsExpanded, setVarianceGLPeriods]);

  return (
    <th className="k-header k-hierarchy-cell" style={{ borderBottomWidth: '0px' }}>
      <ExpandCollapseCell
        expand={isAllItemsExpanded}
        onExpand={handleHeaderCellExpand}
        title="Expand/Collapse All"
      />
    </th>
  );
};
export default VarianceGLPeriodHeaderCell;
